import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { UserDetails } from '../check-in/check-in.interfaces';
import { BaseInitialState, StateStatus } from '../extension-store/interfaces/extension-store.interfaces';

export enum UserAccessType {
  NONE = 'none',
  BASIC = 'basic',
  FULL = 'full',
}

export interface UserProfile {
  email: string;
  id: string;
  domain: string;
  userJWT?: string;
  userOrgUnitPath?: string;
  accessLevel: UserAccessType;
}

interface InitialUserProfileState extends BaseInitialState {
  userProfile: UserProfile;
}

const initialState: InitialUserProfileState = {
  error: null,
  status: StateStatus.IDLE,
  userProfile: {
    email: '',
    id: '',
    domain: '',
    accessLevel: UserAccessType.NONE,
  },
};

export const UserProfileEffects = {
  fetchUserProfile: () => {
    console.log('fetchUserProfile');
  },
};

export const UserProfileState = createSlice({
  name: 'UserProfileReducer',
  initialState,
  reducers: {
    setProfileDetails: (mutableState, action: PayloadAction<UserDetails>) => {
      mutableState.userProfile.accessLevel = action.payload.accessLevel;
      mutableState.userProfile.userOrgUnitPath = action.payload.userOrgUnitPath;
      mutableState.userProfile.userJWT = action.payload.userJWT;
      mutableState.status = StateStatus.SUCCESS;
    },
    setEmail: (mutableState, action: PayloadAction<string>) => {
      mutableState.userProfile.email = action.payload;
    },
    setId: (mutableState, action: PayloadAction<string>) => {
      mutableState.userProfile.id = action.payload;
    },
    setDomain: (mutableState, action: PayloadAction<string>) => {
      mutableState.userProfile.domain = action.payload;
    },
    setUserAccessLevel: (mutableState, action: PayloadAction<UserAccessType>) => {
      mutableState.userProfile.accessLevel = action.payload;
    },
    setUserJWT: (mutableState, action: PayloadAction<string>) => {
      mutableState.userProfile.userJWT = action.payload;
    },
  },
});

export const { setEmail, setId, setDomain, setUserAccessLevel, setUserJWT, setProfileDetails } =
  UserProfileState.actions;

export const getUserProfile = (state: InitialUserProfileState) => state.userProfile;
